module.exports = __webpack_public_path__ + "img/7e7c6d3.jpg";